export const formatDisplayNumber = (number, scale = 2) => {
  try {
    return number.toFixed(scale).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  } catch (err) {
    return number
  }
}

export const removeFormatNumber = (str) => {
  if (str !== null && str !== undefined) {
    if (isNum(str)) {
      // If its already a number, return it
      return str
    } else {
      return str.replace(/\,/g, '')
    }
  } else {
    return str
  }
}

export function isInt(value) {
  if (isNaN(value)) {
    return false
  }
  var x = parseFloat(value)
  return (x | 0) === x
}

export function isNum(value) {
  return !isNaN(value)
}
